import { render, staticRenderFns } from "./Page18.vue?vue&type=template&id=c9ed4c6e&"
import script from "./Page18.vue?vue&type=script&lang=js&"
export * from "./Page18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports